import "./styles/UserMangement.css";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import SearchIcon from "@mui/icons-material/Search";
import { useTable } from "react-table";
import { BasicTable } from "../components/scripts/Table2";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import "../components/styles/QueueContent.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { Box } from '@mui/material';
import "../components/styles/Tabs.css";
import PopOutModal from "../components/scripts/PopOutModal";
import RemoveIcon from "@mui/icons-material/Remove";
import Api_Call from "../ApiCall";
import info from "../info.json";
function UserManagement() {
  const [UserManagementData, setUserManagementData] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [dataForSupervisorDropDown, setDataForSupervisorDropDown] = useState(
    []
  );
  const [
    valueSelectedFromSupervisorDropDown,
    setValueSelectedFromSupervisorDropDown,
  ] = useState("");

  const [table, setTable] = useState("");

  const [roles, setRoles] = useState([]);
  const [valueForRole, setValueForRole] = useState("");

  const [teams, setTeams] = useState([]);
  const [valueForTeams, setValueForTeams] = useState("");
  const [loading, setLoading] = useState();

  const [isDisplay, setIsDisplay] = useState(false);
  const [userID, setUserID] = useState("");
  const [name, setName] = useState("");
  const [empID, setEmpID] = useState("");
  const [email, setEmail] = useState("");
  const [doj, setDoj] = useState("");
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [dataForTable, setDataForTable] = useState([
    {
      USER_ID: "",
      USER_NAME: "",
      ACTIVE: null,
      ROLE: "",
      TEAM: "",
      Supervisor: "",
      EMP_ID: "",
      DATE_OF_JOINING: "",
      EMAIL_ID: "",
    },
  ]);
  const [dataForEdit, setDataForEdit] = useState([]);
  const [isEditPressed, setisEditPressed] = useState(false);

  const [payloadDataForSubmit, setPayloadDataForSubmit] = useState();

  const wt = 200;
  const ht = 50;
  const colms = [
    {
      width: 150,
      height: ht,
      Header: "User ID",
      accessor: "USER_ID",
    },
    {
      width: wt,
      height: ht,
      Header: "User Name",
      accessor: "USER_NAME",
    },
    {
      width: wt,
      height: ht,
      Header: "Email ID",
      accessor: "EMAIL_ID",
    },
    {
      width: 220,
      height: ht,
      Header: "Employee ID",
      accessor: "EMP_ID",
    },
    {
      width: 220,
      height: ht,
      Header: "Supervisor",
      accessor: "SUPERVISOR",
    },
    {
      width: wt,
      height: ht,
      Header: "Supervisor ID",
      accessor: "SUPERVISOR_ID",
    },
    {
      width: wt,
      height: ht,
      Header: "Team",
      accessor: "TEAM",
    },
    {
      width: wt,
      height: ht,
      Header: "Role",
      accessor: "ROLE",
    },
    {
      width: 250,
      height: ht,
      Header: "Date of Joining",
      accessor: "DATE_OF_JOINING",
    },
    {
      width: 100,
      height: ht,
      Header: "Active",
      accessor: "ACTIVE",
    },
    {
      // width: 100,
      height: ht,
      Header: "Action",
      accessor: "",
    },
  ];

  const columns = colms;

  const reSettingStates = () => {
    setEmail("");
    setDoj("");
    setEmpID("");
    setUserID("");
    setValueSelectedFromSupervisorDropDown("");
    setValueForRole("");
    setValueForTeams("");
    setName("");
  };
  // console.log(typeof dataForTable)
  // console.log(dataForTable)

  useEffect(async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData(`SETTINGS/MANAGEMENT?headers=Role,Team`);
      console.log(data.body[1]["Team"]);
      setRoles(JSON.parse(data.body[0].Role));
      setTeams(JSON.parse(data.body[1].Team));
    } catch (error) {
      console.log(error.message);
    }
    // const response = await fetch(
    //   "https://nl0wwss99i.execute-api.us-east-1.amazonaws.com/QA/SETTINGS/MANAGEMENT?headers=Role,Team"
    // );
    // const data = await response.json();

    // console.log(data);

    // console.log(data.body[1]["Team"]);
    // setRoles(JSON.parse(data.body[0].Role));
    // setTeams(JSON.parse(data.body[1].Team));
  }, []);

  useEffect(async () => {
    setLoading(true);

    try {
      const api = new Api_Call();
      const data = await api.getData(`UI/USER_MANAGEMENT`, info.BASE_URL_ADMIN);
      setDataForTable(data.body);
      setDataForSupervisorDropDown([
        ...data.body.map((item) => ({
          name: item["USER_NAME"],
          user_id: item["USER_ID"],
        })),
      ]);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
    // const response = await fetch(
    //   "https://xgauwlgq4a.execute-api.us-east-1.amazonaws.com/QA/UI/USER_MANAGEMENT"
    // );
    // const data = await response.json();

    // console.log(data);
    // setDataForTable(data.body);
  }, []);

  useEffect(() => {
    setPayloadDataForSubmit({
      user_id: userID,
      Emp_ID: Number(empID),
      user_name: name,
      supervisor_id: Number(valueSelectedFromSupervisorDropDown),
      DOJ: doj,
      email_id: email,
      role_ID: Number(valueForRole),
      team: Number(valueForTeams),
    });
  }, [
    empID,
    name,
    valueSelectedFromSupervisorDropDown,
    doj,
    email,
    valueForRole,
    valueForTeams,
  ]);

  console.log(payloadDataForSubmit);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsOpen(false);
    setIsSaveClicked(true);

    if (isEditPressed) {
      try {
        const api = new Api_Call();
        const data = await api.putData(
          `UI/USER_MANAGEMENT`,
          payloadDataForSubmit,
          info.BASE_URL_ADMIN
        );

        console.log(data.body);
        toast.success(data.body.msg);
        setIsDisplay(false);

        console.log("inside------->");
        const newDataForTable = dataForTable.map((item) => {
          if (item["USER_ID"] == data.body.user_details[0]["USER_ID"])
            return data.body.user_details[0];
          return item;
        });
        setDataForTable(newDataForTable);
      } catch (error) {
        console.error("Error submitting form:", error.message);
        toast.error(error.message);
      } finally {
        reSettingStates();
        setisEditPressed(false);
      }
    } else {
      try {
        const api = new Api_Call();
        const data = await api.postData(
          `UI/USER_MANAGEMENT`,
          JSON.stringify(payloadDataForSubmit),
          info.BASE_URL_ADMIN
        );

        console.log(data.body);
        toast.success(data.body.msg);
        setIsDisplay(false);
        if (data.body["user_details"] != "") {
          setDataForTable((prevValue) => {
            console.log(prevValue);
            return [...prevValue, data.body.user_details[0]];
          });
        }
      } catch (error) {
        // Handle error
        console.error("Error submitting form:", error.message);
        toast.error(error.message);
      } finally {
        // setIsSaveClicked(false)

        reSettingStates();
      }
    }
  };

  const valueForEditPopup = (key) => {
    const obj = dataForEdit.find((item) => item.key == key);
    console.log(obj);
    if (obj) {
      return obj.value;
    }
  };
  console.log("data for table-------", dataForTable);

  const displayPopup = () => {
    setIsOpen(true);
    setIsDisplay((prevValue) => !prevValue);
    setIsSaveClicked(false);
  };
  const editHandler = () => {
    displayPopup();
    if (dataForEdit.length > 0) {
      console.log(
        "-------->",
        dataForSupervisorDropDown.find(
          (item) => item.user_id == valueForEditPopup("Supervisor ID")
        )
      );
      const user_id = valueForEditPopup("User ID");
      const email_edited = valueForEditPopup("Email ID");
      const doj_edited = valueForEditPopup("Date of Joining");
      const empId_edited = valueForEditPopup("Employee ID");
      const superId_edited = valueForEditPopup("Supervisor ID")
        ? dataForSupervisorDropDown.find(
            (item) => item.user_id == valueForEditPopup("Supervisor ID")
          )["user_id"]
        : "";

      const role_edited = valueForEditPopup("Role")
        ? roles.find((item) => item.Value == valueForEditPopup("Role"))["ID"]
        : "";
      const team_edited = valueForEditPopup("Team")
        ? teams.find((item) => item.Value == valueForEditPopup("Team"))["ID"]
        : "";
      const name_edited = valueForEditPopup("User Name");
      setEmail(email_edited);
      setDoj(doj_edited);
      setEmpID(empId_edited);
      setValueSelectedFromSupervisorDropDown(superId_edited);
      setValueForRole(role_edited);
      setValueForTeams(team_edited);
      setName(name_edited);
      setUserID(user_id);
    }
    setDataForEdit([]);
    // setisEditPressed(false);
  };

  useEffect(() => {
    if (isEditPressed) editHandler();
  }, [dataForEdit.length]);
  console.log("Edit Data", dataForEdit);
  console.log(payloadDataForSubmit);
  console.log("Edit Pressed", isEditPressed);
  // console.log(valueSelectedFromSupervisorDropDown)
  // console.log(teams);
  // console.log(isDisplay)
  // console.log("name",name);
  // console.log("email",email);
  // console.log("empid",empID);
  // console.log("doj",doj);

  console.log(isSaveClicked, isDisplay);
  console.log(dataForEdit);

  return (
    <>
      {/* <div className="header__um">
        <div
          className="header__um--user-details"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <div>
            <p className="header__um--user-details-name">Chloe Kristan</p>
            <p>chloekristan1990@gmail.com</p>
          </div>
          <PersonIcon className="header__um--user-details-icon" />
        </div>
      </div> */}
      <Box className="primary-title-new">
        <img src="img/heading-bg.png" />
        <Typography variant="h1">User Management</Typography>
      </Box>

      <div className="body_um">
        {/* <div className="body_um__left">
          <ul className="body_um__left--options">
            <li>Details</li>
            <li>Reoprting Details</li>
            <li>Profile</li>
          </ul>
        </div> */}

        <div className="body_um__right">
          <div className="body_um__right-top">
            <div
              style={{
                display: "flex",
                justifyContent: " space-between",
                alignItems: "center",
              }}
            >
              {/* <div style={{ fontWeight: "400", fontSize: "18px" }}>
                Home/ User Management
              </div> */}
              <span class="body_um__right--search">
                {/* <input placeholder="Search"></input> */}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: " space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              {/* <div style={{ fontWeight: "200", fontSize: "14px" }}>
                Employee Details
              </div> */}
              {/* <span class='body_um__right--buttons'><span onClick={()=>{setIsDisplay(prevValue=>!prevValue); setIsSaveClicked(false) }}> {isDisplay}?{<AddIcon className='body_um__right--buttons--add'/>}Add:{<RemoveIcon className='body_um__right--buttons--add'/>}View</span><span><EditIcon className='body_um__right--buttons--edit'/>Edit</span><span></span></span> */}
              {/* <span class="body_um__right--buttons">
                <span
                  onClick={() => {
                    displayPopup();
                  }}
                >
                  {/* {isDisplay ? (
                    <RemoveIcon className="body_um__right--buttons--add" />
                  ) : ( 
                  <AddIcon className="body_um__right--buttons--add" />
                  {/* )} Add
                  {/* {isDisplay ? "View" : "Add"} 
                </span>
                <span>
                  <EditIcon className="body_um__right--buttons--edit" />
                  Edit
                </span>
                <span></span>
              </span> */}
            </div>

            {/* {isSaveClicked && } */}
            <ToastContainer />

            <PopOutModal
              heightPopUp="65%"
              isOpen={isOpen}
              onClose={() => {
                setIsOpen(false);
                setisEditPressed(false);
                reSettingStates();
              }}
              bigPopUpHeight=""
              content={
                // !isSaveClicked &&
                // isDisplay && (
                <div>
                  <div className="popup--user--heading">
                    {isEditPressed ? "Edit " : "Add "}User
                  </div>
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <div
                      className="body_um__right--main"
                      // style={!isDisplay ? { display: "none" } : {}}
                    >
                      <div className="body_um__right--main-1">
                        <div class="body_um__right--main-1--input-container">
                          <label for="username">
                            Name{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            id="username"
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                            }}
                            required={!isEditPressed ? true : false}
                          />
                        </div>
                        {/* <span>
   </span> */}

                        <div class="body_um__right--main-1--input-container">
                          <label for="employeeid">
                            Employee ID{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            id="employeeid"
                            required={!isEditPressed ? true : false}
                            disabled={isEditPressed ? true : false}
                            value={empID}
                            onChange={(e) => {
                              setEmpID(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="body_um__right--main-2">
                        <div class="body_um__right--main-2--input-container">
                          <label for="email">
                            Email Address{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <input
                            type="email"
                            id="email"
                            required={!isEditPressed ? true : false}
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                            }}
                          />
                        </div>

                        {/* <div class="body_um__right--main-2--input-container">
   <label for="dob">Date of Birth</label>
   <input type="date" id="dob" placeholder=''/>
  </div> */}

                        <div class="body_um__right--main-2--input-container">
                          <label for="doj">
                            Date of Joining{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <input
                            type="date"
                            id="doj"
                            placeholder=""
                            required={!isEditPressed ? true : false}
                            disabled={isEditPressed ? true : false}
                            value={doj}
                            onChange={(e) => {
                              setDoj(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div class="body_um__right--main-1">
                        {/* <div class="body_um__right--main-1--input-container"> */}
                        <div class="body_um__right--main-1--input-container">
                          <label for="username">
                            Supervisor{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <select
                            type="text"
                            id="username"
                            value={valueSelectedFromSupervisorDropDown}
                            onChange={(e) =>
                              setValueSelectedFromSupervisorDropDown(
                                e.target.value
                              )
                            }
                            required={!isEditPressed ? true : false}
                          >
                            <option value="" disabled selected>
                              Select Value
                            </option>
                            {dataForSupervisorDropDown.map((item) => (
                              <option value={item["user_id"]}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div class="body_um__right--main-1--input-container">
                          <label for="team">
                            Team{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <select
                            type="text"
                            id="team"
                            value={valueForTeams}
                            onChange={(e) => setValueForTeams(e.target.value)}
                            required={!isEditPressed ? true : false}
                          >
                            <option value="" disabled selected>
                              Select Value
                            </option>
                            {teams.map((item) => (
                              <option value={item["ID"]}>
                                {item["Value"]}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* <span>
   </span> */}

                        <div class="body_um__right--main-1--input-container">
                          <label for="role">
                            Role{" "}
                            {isEditPressed ? (
                              ""
                            ) : (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <select
                            type="text"
                            id="role"
                            value={valueForRole}
                            onChange={(e) => setValueForRole(e.target.value)}
                            required={!isEditPressed ? true : false}
                          >
                            <option value="" disabled selected>
                              Select Value
                            </option>
                            {roles.map((item) => (
                              <option value={item["ID"]}>
                                {item["Value"]}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div class="body_um__right--main-save">
                        <div class="body_um__right--main-button">
                          <button>Save</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              }
            ></PopOutModal>

            <div>
              <div className="content-main">
                <div className="user-content-container">
                  <div className="tasklist-table specific-table">
                    <Box>
                      <BasicTable
                        basic="true"
                        columns={colms}
                        editHandler={editHandler}
                        tableData={dataForTable}
                        setDataForEdit={setDataForEdit}
                        setisEditPressed={setisEditPressed}
                        loading={loading}
                        addHandler={() => {
                          displayPopup();
                        }}
                      ></BasicTable>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserManagement;
